angular.module('cfn').factory('cfnGridDefaults', function() {
  var defaults = {
      column: {
        displaysize: 4,
        displayprio: 1
      },
      view: {
        perPage: 50 // how many items per page
      },
      headerHeight: 41,
      viewUpdateInterval: 250
    },
    constants = {
      nonFixedWidthFactor: 30
    };

  return {
    defaults: defaults,
    constants: constants
  };
});
